import { brand } from '@brand';
import { useBootstrap } from '@/lib/api/hooks';

/**
 * Support address shown to the signed-in patient: bootstrap's help contact,
 * else the brand fallback. The storefront flavor swaps this module
 * (vite.config.ts RXSTORE_MODULE_SWAPS) for one that follows the store the
 * patient chose.
 */
export function useSupportEmail(): string {
  const { data } = useBootstrap();
  return data?.help_contact?.email ?? brand.supportEmail;
}
